export default {
  //  商品编辑分类
  classify: {
    placeholder: 'Input keyword to search and select a product Category',
    known_btn: 'I have read the notice and  confirm to upload the product',
    selected: 'selected：',
    notice: `Notice：Choosing the best category ensures that you see the most appropriate data fields for your product. `
  },
  goodsInfo: {
    price_formula_hint: 'This recommended price does not include category commission and return costs',
    pirce_reference: 'Price reference formula',
    expected_profit: 'Expected profit',
    Domestic_freight_cost: 'Domestic freight cost',
    goodsCost: 'Commodity cost price',
    goodsWeight: 'Weight of goods',
    goodsLong: 'Length',
    goodsWidth: 'Outer packing width',
    goodsHeight: 'Height of packing',
    suggested_retail_price: 'Suggested retail price',
    mian_img_btn_content: 'Replace',
    Draft_Hint: 'Please add the item title before saving',
    batch: 'Batch',
    hint: 'Hint',
    img_move_hint: 'Drag and drop pictures to reorder',
    goodsDetailsHint: 'The details of the goods cannot be left blank.',
    mainImgHint: 'No more than ',
    mainImgHint1: 'main image can be uploaded',
    nonblankHint: 'Name/attribute/code/main map cannot be empty, please fill in and resubmit',
    losgNonblankHint: 'Basic logistics information (goods width/height/length/weight/type...), is empty or incomplete, please fill in and resubmit',
    spceNonblankHint: 'The content of the specification area is empty or incomplete, please fill in and resubmit',
    spceNonblankHint1: 'One value must be filled in for each specification value. Please fill in and resubmit',
    spceImgHint: 'The specification diagram cannot be empty',
    spce_edit_hint: '  Adding, modifying, or deleting a specification value will clear the data. Do you want to continue?',
    brandHint: 'Please select the brand',
    wordLengthHtin: 'Maximum 200 characters',

    goodsDesc: 'Please fill in the product description',
    lengthChar: 'The length ranges from 0 to 200 characters',
    titleHint: 'Please enter the title',
    product_code_hint: 'Please enter the commodity code',
    trademark: 'Trademark:',
    tabbar1: 'Category',
    tabbar2: 'Sales Information',
    tabbar3: 'After-sale information',
    tabbar4: 'Logistic information',
    tabbar5: 'other information',
    title1: 'Basic information',
    title2: ' Marketing information',
    title3: 'Details',
    tilte4: 'Logistic information',
    classify: 'Category:',
    alter: 'Modify ',
    headline: 'Title:',
    property: 'Attributes：',
    goodsHint: `Please fill in the attributes accurately, which will help the product to be exposed in the search and recommendation. If you fill in the wrong information, you may face product removal or traffic loss!`,
    property_plan: 'Attribute complete rate: ',
    alterinput_placeholder: 'Please enter',
    product: ' Product:',
    texture: '材质:',
    production: 'Place of Origin',
    goodsImg: ' Main image:',
    goodsVideo: 'Product video:',
    goodsDec: ' Description:',
    specification: 'Product Variation',
    specificationName: 'Variation Name',
    color: 'Color',
    specificationNum: 'Variation value:',
    placeholde_select: 'Please Select',
    speci_select_placeholder: 'Select or enter',
    add_specificationNum: 'Add variation',
    Remove_specificationNum: 'Remove Variation value',

    size: '尺寸',
    specificationDet: 'Specifications:',
    price: 'Price',
    repertory: 'Stock',
    tatol_repertory: 'The total inventory',
    sale_price: ' Selling price',
    Specifications_code: 'Code',
    specification_code: 'Merchant Code',
    cost_price: 'Sourcing Cost',
    specification_img: 'Specs image',
    blck: '黑',
    white: '白',
    big: '大',
    center: '中',
    small: '小',
    set_batch: 'Batch Setting',
    market_price: 'Market price',
    settlement_amount: 'Settlement amount:',
    inventory_warning: 'Inventory warning value',
    purchase_limitation: 'Buy limit',
    warehouse: 'Warehouse:',
    goodsDetaiImg: 'Details:',
    move: 'Mobile',
    PC: 'PC',
    canImg: '',
    numImg: 'pictures',
    canInput: '',
    word: ' words',
    Picture: 'Image',
    World: 'Text',
    state: '从PC导入说明',
    PC_hint: 'Note: It is suggested that seller edit the mobile product description individually for better layout. Otherwise PC description will be shown by default.(may not look good).',
    hint_H1: '1、Basic Requirements： ',
    hint_p1: '1）Mobile phone details of the overall size: picture + text, no more than 20 pictures, text is not more than 5000 words; Recommendation: all pictures are related to the baby.',
    hint_p2: 'Suggestion: All pictures are related to baby',
    hint_H2: '2、Picture Size Requirement：',
    hint_p3: '（1）Recommended to use the width of 620 ~ 480 pixels, a height of less than 960 pixels;',
    hint_p4: '（2）Format: JPG\JEPG\GIF\PNG; For example: you can upload a width of 480, a height of 960 pixels, the format of the picture JPG.',
    hint_p5: 'For example: You can upload a picture with a width of 480, a height of 960 pixels, and a picture in JPG format',
    hint_H3: '3、Text requirement：',
    hint_p6: '（1）Each insert text can not be more than 500 words, punctuation, special characters in accordance with a word calculation; ',
    hint_p7: '（2）Please manually enter the text, do not copy and paste the text on the page, to prevent garbled;',
    hint_p8: '（3）The following special characters "", "", "", "", "" "", "" will be replaced by empty. Recommendation: do not add too much text, so it looks more clear.',
    hint_p9: 'Suggestion: Don’t add too much text, it will look clearer.',
    submit: 'Submit',
    Save_drafts: 'Save as draft',
    Weight: 'Weight(g):',
    Freight_Setting: 'Freight Setting:',
    Weight_hint: ' Inaccuracy of weight may incur settlement delay.',
    Packing_size: 'Packing size(cm):',
    Length: 'Length',
    upload_img_hint: 'Upload pictures can only be JPG, JPEG, PNG, GIF format!',
    upload_img_hint1: 'Upload pictures should not be larger than 5MB!',
    Width: 'Width',
    Height: 'Height',
    Packing_size_hint: 'Inaccuracy of packing size may incur settlement delay.',
    Shape: 'Shape:',
    Hazardous_Cargo: 'Hazardous Cargo:',
    yes: 'Yes',
    no: 'No',
    Hazardous_Cargo_hint: 'Hazardous Cargo including explosive, gas flammable, radioactive substances, corrosive substancesm miscellaneous dangerous substances and articles.',
    Contains_Battery: 'Contains Battery:',
    Contains_Battery_hint: 'Whether the goods or goods containing battery. ',
    Product_Type: 'Product Type:',
    Tax_Class: 'Tax Class:',
    Other_Information: 'Other',
    New_Category: 'New Category:',
    Shop_Category: 'Shop Category:',
    New_Category_hint: 'Can be Product belong to the shop of multiple classifications - > shop - > store > classification in custom',
    Upload: 'Upload ',
    UploadImage: 'Upload image',
    UploadVideo: 'Upload video',
    UploadVideo1: 'Local upload',
    tip_video: 'Please ensure that the video format(mp4) is correct and does not exceed 10M.',
    tip_img: 'Please ensure that the image format(jpg、jpeg、png、gif) is correct',
    tip_video1: 'Please upload the correct video format(mp4)',
    tip_video2: 'The size of uploaded video should not exceed 10MB.',
    tip_video3: 'Video upload failed, please reupload.',
    change_video_btn: 'Delete',
    video_photo: 'Video album',
    Category: 'Category',
    Type: 'Type',
    Brand_New: 'Brand New',
    Second_Hand: 'Second Hand',
    Product_Name: 'Product Name',
    Short_Description: 'Short Description',
    Specification: 'Specification',
    please: 'Please fill in the attributes accurately, which will help the product to be exposed in the search and recommendation. If you fill in the wrong information, you may face product removal or traffic loss!',
    spec_rate: 'Specification Completion Rate',
    cant_apply: 'Cant find it, click to apply',
    Carousel: 'Carousel/Video',
    white_image_name: 'White background image',
    white_image_msg: 'Upload the white background image to get more resources and traffic exposure, it is recommended to upload',
    white_image_size_msg: 'Please upload a picture smaller than 1M',
    white_image_width_msg: 'Please upload a picture with a width greater than 400',
    white_image_bj_msg: 'Please choose a pure white background image',
    white_image_ratio_msg: 'Please upload a 1:1 ratio',
    image_require: 'Image requirements: the width and height are equal and greater than 480px, and the size is within 1M. Drag and drop to adjust the order.',
    video_require: 'Video requirements: only support 1 video that does not exceed 10M in size and format is MP4, flv, avi, wmv',
    main_iamge: 'Main image carousel',
    upload_image: 'upload image',
    Detailed_Desc: 'Detailed Description',
    Preview: 'Preview',
    Play: 'Play',
    Refresh: 'Refresh',
    Quick_edit: 'Quick edit',
    Add_images: 'Add images',
    Add_videos: 'Add videos',
    Add_text: 'Add text',
    image_have: '10 images have been uploaded, the order can be adjusted by dragging.',
    most_two: 'At most two product specifications can be added, and the first product specification can add specification images.',
    Variation_sort: 'Variation Value Sort',
    Price_Inventory: 'Price and Inventory',
    please_fill: 'Please fill in the inventory information truthfully to ensure that the product can be shipped within the promised delivery time to avoid possible logistics violations.',
    Inventory_warning: 'Inventory warning value',
    increase: 'Increase',
    decrease: 'Decrease',
    Inventory_Adjustment: 'Inventory Adjustment',
    Merchant_Product: 'Merchant Product ID',
    Assoicate_skus: 'Assoicate previous SKUs',
    Is_liquid: 'Is it liquid',
    Is_fragile: 'Is it fragile',
    does_contain: 'Does it contain batteries',
    Whether: 'Whether it is magnetic',
    After_sales: 'After-sales Service',
    Publish_Now: 'Publish Now',
    unpublished: 'Save as unpublished',
    Image_Gallery: 'Image Gallery',
    Video_Gallery: 'Video Gallery',
    Aspect: '(Aspect ratio>= 1:3, width above 480px, size within 1M)',
    image_name: 'Please enter the image name',
    folder_name: 'Please enter the folder name',
    No_data: 'No data',
    Start_upload: 'Start upload',
    Please_content: 'Please enter content',
    Please_time: 'Please choose a time',
    Brand_Application: 'Brand Application',
    Approval_Status: 'Approval Status',
    Brand_Name: 'Brand Name',
    Application: 'Application',
    Pending_audit: 'Pending audit',
    Passed: 'Passed',
    Rejected: 'Rejected',
    Number_categories: 'Number of categories',
    Application_time: 'Application time',
    Audit_time: 'Audit time',
    Status: 'Status',
    Remark: 'Remark',
    Apply_brand: 'Apply for a new brand',
    Brand_Image: 'Brand Image',
    Brand_Authorization: 'Brand Authorization File',
    click_Upload: 'Upload',
    belong_Category: 'Category',
    Add_gift: 'Add a new gift',
    Number_gifts: 'Number of gifts',
    Gift_effective_time: 'Gift effective time',
    Settings: 'Settings',
    Gift_SKU_ID: 'Gift SKU ID',
    Gift_Name: 'Gift Name',
    Gift_thumbnails: 'Gift thumbnails',
    Variation: 'Variation',
    Effective_time: 'Effective time',
    Operate: 'Operate',
    Because: 'Because the main product is FBK product, so only FBK products can be searched and selected.',
    Gift_SKU_Name: 'Gift SKU Name',
    Estimated: 'Estimated current inventory',
    Search: 'Search',
    Operating_time: 'Operating time',
    Edit: 'Edit',
    More: 'More',
    Repair: 'Repair point template download',
    Click_view: 'Click to view',
    Import_Excel: 'Import Excel',
    Exceeding: 'Exceeding optional variation',
    Cannot_enter: 'Cannot enter a duplicate variation name',
    selling_price: 'The selling price must be higher than the cost price',
    selling_must: 'The selling price must be higher than the cost price',
    Please_enter: 'Please enter the required variations',
    Please_required: 'Please enter SKU required information',
    Cannot_duplicate: 'Cannot enter duplicate variation values',
    Please_variation: 'Please enter the required variation name',
    Cannot_enter_duplicate: 'Cannot enter duplicate variation values',
    Please_ente_variation: 'Please enter the required variation name',
    Publish_Successful: 'Publish Successful',
    Successfully_Unpublished: 'Successfully Unpublished',
    Please_select: 'Please select at least one product that has been published',
    Whether_unpublish: 'Whether to unpublish the goods',
    Successfully_unpublished: 'Successfully unpublished in batches',
    Edit_successfully: 'Edit successfully',
    Please_correct_format: 'Please enter the correct data format',
    Draft_box: 'Draft box modified successfully',
    saved_successfully: 'The draft was saved successfully',
    sales_information: 'Please enter required sales information',
    video_picture: 'Please upload a video or picture',
    Vat_select: 'Please select Tax class',
    Added_product: 'Added product successfully',
    rejection_statement: 'Please fill in the rejection statement',
    Audit_Submitted: 'Audit Submitted Successfully',
    select_category: 'Please select a category',
    Whether_product: 'Are you sure to delete this product',
    Please_effective: 'Please check the effective time and quantity of the gift',
    product_discribtion: 'Add up to 30 product discribtion images',
    Only_support: 'Only support 5 options at most',
    uploaded_avatar: 'The size of the uploaded avatar image cannot exceed',
    Please_delete: 'Please delete the selected before uploading',
    uploaded_image: 'The uploaded image must be in JPG/GIF/PNG/BMP format',
    Upload_image_cannot: 'Upload image size cannot exceed 2MB',
    Please_category: 'Please enter the category name to be added',
    Please_enter_content: 'Please enter content',
    Choose_date_time: 'Choose date',
    Page_view: 'Preview',
    Uploaded: 'Uploaded',
    Input_text: 'Enter text',
    Custom_attributes: 'Custom variation',
    Please_type: 'Please enter  type',
    Cannot_enter_attribute: 'Can not enter duplicate value',
    Brand_name: 'Brand name',
    Brand_image: 'Brand image',
    Brand_authorization_file: ',Brand authorization file',
    size_picture: 'Size: w150px * h50px , less than 1Mb',
    Please_enter_brand: 'Please enter the brand name',
    Select_picture: 'Please enter brand name',
    Customs_code: 'Customs_code',
    Click_customs_code: 'Check custom code',
    Customs_Code_Name: 'Customs code name',
    Customs_code_attribute: 'Customs code attribute',
    Type_cargo_transportation: ' Product Type',
    Cuboid: 'Cuboid',
    Cylindrical: 'Cylinder',
    Sphere: 'Sphere',
    Irregular: 'Irregular body',
    General_cargo: 'General Product',
    Mobile_phone: 'Phone/Tablet/Laptop',
    Special_goods: 'Special Product (powder, liquid, ointment)',
    Electromagnetic: 'Electronics goods  (with battery, charger, with magnetism)',
    HighlySensitiveProducts:'Highly Sensitive Products',
    Please_enter_weight: 'Please enter weight(g)',
    Please_enter_packaging: 'Please enter length(cm)',
    Please_enter_Wide: ',Please enter width(cm)',
    Please_enter_Hight: 'Please enter height(cm)',
    The_list_only: 'Only display successfully uploaded',
    Select_picture_video: 'Select picture/video',
    video: 'video',
    Add: 'Add',
    Click_load_more: 'Click to load more',
    Added: 'Added',
    Please_enter_value: 'Please enter variation value',
    Please_enter_warehouse: 'Please enter warehouse name',
    sort_directly: 'You can drag to sort directly',
    Specification_value: 'Variation value',
    Please_custom_attributes: 'Please enter custom variation value',
    Please_customize_attributes: 'Please enter customized variation',
    Commodity_category: 'Category:',
    Export: 'Export',
    Check: 'Check',
    Voucher: 'Voucher',
    CouponCode: 'Coupon Code',
    Airtime: 'Airtime',
    GeneralProducts: 'General Products',
    Refurbish: 'Refurbish',
    Vat: 'Tax class',
    PackingList: 'What\'s in the box: ',
    PlaceholderPackingList: 'To avoid unnecessary after-sales services, please fill in the product list, including what\'s in the box.',
    PleaseEnterPackingList: 'Please enter what\'s in the box:',
    ProductSize: 'Product Size Chart: ',
    PleaseEnterProductSize: 'Please select the product size chart'
  },
  goodsManage: {
    Mobile: 'Mobile',
    General_Goods: 'General Goods',
    Pictures_All: 'Pictures All',
    Album_User: 'Album User',
    Put_in_Waregouse: 'Put in Waregouse',
    Release: 'Publish',
    inventory_warning_hint: 'Please make sure to enter an integer greater than or equal to 0 and less than the inventory',
    price_hint: `Please make sure it is greater than or equal to 0`,
    prices_hint1: 'The price set in batches must be greater than the cost price and less than the market price in the table',
    inventory_hint: `Please make sure to enter an integer greater than or equal to 0 and less than the inventory warning value`,
    integer_hint: `Please make sure to enter an integer greater than or equal to 0`,
    prices_hint: `Please make sure it is a positive integer, cannot be lower than the cost price and cannot be higher than the market price`,
    costPrice_hint: 'Please make sure it is an integer greater than or equal to 0, and cannot be greater than the selling price',
    market_price_hint: 'The market price cannot be lower than the selling price',
    inventory_warning_hint1: `The inventory value set in batches must be greater than the largest inventory warning value in the table`,
    inventory_warning_input_hint1: 'Must be less than the smallest inventory in the table',
    cost_price_input_hint1: 'The cost price set in batches must be less than the smallest selling price in the table',
    sold_out_hint_content: ' Confirm unpublish this product?',
    stock: 'Inventory',
    CreationTime: 'Creation time',
    CumulativeSales: 'Cumulative sales',
    Favorites: 'Favorites',
    Listing_status: 'Publish Status',
    The_current_inventory: 'Current  inventory',
    Modify_the_inventory: 'Modify inventory',
    select_sold_out: 'Off shelf in batches',
    goods_manage: 'Product management',
    Logistics_type: 'Logistics_type',
    has_sales: 'Whether there is sales',
    goodsNmae: 'Product Name',
    Product_platform: 'Platform Product ID',
    max_price: 'Maximum price',
    min_price: 'Minimum price',
    goods_SKU_ID: 'SKU ID',
    goods_common_ID: 'Porduct ID (Listing id)',
    search: 'Search',
    addGoods: 'Add New Product',
    // 批量改价
    batchPrice: 'Batch Price Modify',
    limitPriceChange: 'There are only 2 changes per day, and each modification takes tens of seconds to tens of minutes.',
    reminderOfTimesLimit: "You can't modify f until tomorrow because you've already modified 2 times today.",
    exportProducts: 'Export products',
    allProducts: 'All products',
    saleProducts: 'On sale products',
    exportTemplate: 'Export Template ',
    UploadFiles: 'Upload files',
    SelectFiles: 'Select files',
    batchPriceCancel: 'Cancel',
    batchPriceSubmit: 'Submit',
    importedSuccess: 'Imported  Successfully',
    setType: 'Set up store categories in batches',
    alter: 'Modify',
    goodsInfo: 'Product Information',
    present_price: 'Current price',
    putaway: 'Publish',
    sold_out: 'Unpublish',
    set_inventory: ' Set up inventory in batches',
    comfirm: 'Comfirm',
    close: 'Close',
    comfirm_set: 'Confirm Settings',
    alter_repertory: 'Modify  inventory ',
    detele_hint: 'Delete Alert',
    sold_out_hint: 'Unpublish Alert',
    Tips_for_listing: 'Publish Alert',
    Tips_for_listing_content: 'Confirm publish this product?',
    all: 'All',
    on_offer: ' On Sale',
    SOLD_OUT: 'Sold Out',
    In_the_warehouse: 'Unpublished',
    detele_hint1: ' Confirm delete this product?',
    detele_hint2: ' Can not retrieve after deletion',
    sold_out_hint1: 'Confirm unpublish this product?',
    storeType: 'Store Category',
    SKU_image: 'Preview',
    product_sku_filter_item: 'Filter Item',
    product_sku_image: 'SKU Image',
    SKU_Detail: 'SKU Details',
    Platform_product: 'Porduct ID (Listing id)', // 'Platform Product ID',
    sku_code: ' SKU ID',
    there_gift: 'Whether bind gift ',
    Price_segment: 'Price Range',
    Sale_price: 'Selling Price',
    gift: 'Gift',
    Modified_time: 'Modify Time',
    status: 'Status',
    On_sale: "On sale",
    the_shelf: 'Unpublished',
    View_gifts: 'View gifts',
    Bound_gift: 'Bind gift',
    Duplicate: 'Duplicate',
    DuplicateErrorMsg: 'You can not create a same product.',
    select_all: 'select All',
    Modify_sales_price: 'Modify sales price',
    Already_below_cost: 'Higher than market price',
    Serial_number: 'Serial number',
    Category: 'Category',
    categories: 'Categories',
    application: 'Application Time',
    Review_time: 'Audition Time',
    Pending_review: 'Pending Audit',
    passed: 'Passed',
    Rejected: 'Rejected',
    illustrate: 'Illustrate',
    Approval_Status: 'Audit Status',
    examination_passed: 'Passed',
    Review_rejected: "Rejected",
    Brand_review: 'Brand Audit',
    Audit: 'Audit',
    source: 'Source',
    Bound_category: 'Bind Category',
    Authorization_file: 'Authorization File',
    reason: 'Reason',
    pass_through: 'Passed',
    Refuse: 'Rejected',
    Recently_Used: 'Recently Used',
    Operator: 'Operator',
    successfully_deleted: 'Delete Successful',
    hint: 'Hint',
    selected: 'Selected',
    information: 'Bind gift information',
    start_date: 'Start date',
    End_date: 'End date',
    return_product: 'Return to product list',
    successfully: 'Submitted successful',
    Submission: 'Failed to submit',
    Please_required: 'Please enter the required description',
    Available_now: 'Publish Now',
    Not_the_shelf: 'Save as unpublished',
    from_sku_sn: 'Merchant product code',
    name: 'Name',
    gallery: 'Gallery',
    product_name: 'Please enter product name',
    enter_sku_code: 'Please enter sku code',
    proportion: 'Aspect ratio>=1:3, width above 480px, size within 1Mb',
    proportion_white: 'Aspect ratio>=1:1, width above 480px, size within 1Mb',
    Undeleted: "Undeleted",
    Cancel: 'No',
    delete: 'Yes, delete',
    Notlogged: "Not logged in or the login information has expired, please log in again.",
    Theverification: "The verification code is wrong, please re-enter",
    Youdo: "You do not have the permission to operation on demonstration environment",
    Nopermission: "No permission for current operation",
    Wronguser: "Wrong user name or password",
    Requesterror: "Request error",
    Unknown: "Unknown system error, please report to the administrator.",
    qualityscore: 'Information qualityscore',
    ProductRating: "Product Rating",
    places: "places to be optimized",
    calculated: 'The score calculated by the system algorithm based on the completeness and standardization of the product information is used to measure the quality of the product information',
    obtaining: 'The higher the information quality score, the higher the ability to obtain traffic, and the more channels for obtaining traffic',
    Customer: 'Customer reviews',
    divided: 'Product Information quality is divided into',
    immediately: 'It is recommended that you deal with it immediately',
    optimize: 'To optimize',
    recommend: 'We recommend to optimize the following issues',
    Noscore: 'No score',
    Optimizing: 'Optimizing the accuracy of the product title needs to match the category',
    business: 'Optimize and improve the content and pictures of the business detailed business description',
    filling: 'Optimize and perfect the attribute filling rate',
    diagram: 'Please improve the number of master diagram',
    improve: 'Please improve the title length',
    uploaded: 'The product has not uploaded a white background image',
    todolist: 'To Do List',
    Announcements: "Announcements",
    BusinessDashboard: "Business Dashboard",
    MarkrtingEvents: "Marketing Events",
    lowercase: "The suffix of the video file name you upload must be lowercase .mp4",
    imageVideo: 'The product did not upload the main image video',
    descriptionVideo: "The product did not upload a description video"
  },
  tagManagement: {
    KiliShop: 'KiliShop',
    Rider: 'Rider',
    tagType: 'Tag Type',
    addTag: 'Add New Tag',
    tag: 'TAG',
    type: 'Type',
    tagContent: 'Tag Content',
    ReviewsMangment: 'Product Review Management',
    OrderID: 'Order Number',
    ListingID: 'Product ID',
    keyword: 'Product Name',
    Total: 'Found',
    items: 'Reviews',
    Only: ',Only 10 are displayed',
    Details: 'Review Details',
    OrderInfo: 'Order Information',
    ReviewTAG: 'Review Label',
    NoData: 'No Data',
    Reply: 'Reply Customer Review',
    Reply1: "Reply",
    PleaseEnterReply: 'Please enter the content you want to reply',
    Reviews: "Rating Star",
    ExplainContent: 'Reply content',
    content: 'Comment',
    ReviewsHint: 'Use product review management to track buyers satisfaction for your products。You can view short-term and long-term indicators, as well as detailed review entries, including buyer information and order numbers。Click "Order Number" to view transaction details in the "Manage Orders" section of Seller Center',
    Feedback_Rating: 'Rating Score',
    all: 'All',
    star: '1 star',
    star1: '2 stars',
    star2: '3 stars',
    star3: '4 stars',
    star4: '5 stars',
    Filter: 'Quick Filter',
    days30: '30 days',
    days90: 'Last 90 days',
    days180: 'Last 180 days',
    comment_content: 'Review Content',
    Is_picture: 'Has pictures?',
    Is_reply: "Has replies?",
    Whether_content: 'Has comments?',
    With_Content: 'With Content',
    NO_Content: 'NO Comment',
    No_Comment: 'no reply',
    With_Comment: 'Replied',
    No_Photos: 'No picture',
    With_Photos: 'Has pictures',
    time: 'Time'
  },
  businessReport: {
    Details: 'Details',
    ProductPage: 'Product Report',
    startTime: 'start time',
    endTime: 'end time',
    StatisticalTime: 'Statistics Period',
    reducedTime: 'Comparision Period',
    Visitors: 'Visitors',
    ProductsViews: "Pageviews",
    Totalitemsold: 'Paid Quantity',
    CustomersPaid: "Paid Buyers",
    OrdersPaid: "Paid Orders",
    AmountPaid: "Paid Amount",
    PaymentConversionRate: 'Payment Conversion Rate',
    Favorites: 'Product Likes',
    CloseTheTip: 'Are you sure to turn it off?',
    Yesterday: 'Yesterday',
    days7: 'Last  7 days',
    days14: 'Last 14 days',
    date: 'Date',
    hint: 'Unique users who visited your product. Only count once when a single user visited a product many times.',
    hint1: 'Product pageviews. Each and every product page clicked and visited count.',
    hint2: 'The total quantity of the product in all paid orders',
    hint3: 'Unique users who made purchase and payment of your product. Only count once when a single buyer made several purchases',
    hint4: "The total number of paid orders for the product. Eg. we will count 3 when a single buyer made 3 purchases contains 9 pcs of the product.",
    hint5: 'The total amount of paid orders for the product',
    hint6: 'The percentage of product visitors who made purchase and payment of the product.',
    hint7: 'Tha accumulative number of product likes up to select date . One user can only like your each and every products once.',
    detailTitlteHint: 'You can hide or show the graph of the indicator by clicking on the indicator'

  },
  // 商家活动后台
  BusinessActivity: {
    Status: 'Status',
    ApplyTime: 'Apply Time',
    activitySetting: 'Flash sale discount must be greater than',
    activitySetting1: ' or price reduction must be greater than',
    activitySetting2: 'Must be >=',
    flashPrice_hint: 'Please make sure that the amount entered is greater than or equal to zero, and the price is low',
    Withdrawhint: 'Recall this product, confirm to continue?',
    joinHint: 'Apply this product, confirm to continue?',
    Sold: 'Sold',
    DateStage: 'Date & Stage',
    RefuseCause: 'Reject Reason',
    FlashStorage: 'Flash Sale Inventory',
    FlashPrice: 'Flash Sale Price',
    Join: 'Join',
    SearchType: 'Search Type',
    Lastjointime: 'Application End Time',
    ActivityStartTime: 'Event Start Time',
    JoinNow: 'Apply Now',
    JoinRecord: 'Application Records',
    JoinTime: 'Application Time',
    ActivityTime: 'Event time',
    End: 'End',
    ComingUp: 'Coming Up',
    ActivityDescription: 'Event Description',
    JoinRequirements: 'Application Requirements',
    RequirementsForgooods: 'Requirements for Products',
    Requirements: 'Event Requirements',
    DescriptionOfRequirements: 'Requirements Details',
    ComplianceWithRequirements: 'Whether it meets',
    Cancel: 'Cancel',
    JoinNows: 'Join Now',
    AllMerchandise: 'All products',
    NonRegistrableItems: 'Unacceptable Products',
    WareHouse_type: 'WareHouse_type',
    Search: 'Search',
    ReasonsApply: 'Reasons for not being able to apply',
    JoinAgain: 'Join Again',
    SelectedJoinNow: 'Submit',
    CommodityCode: 'Commodity Code',
    PleaseEnterCode: 'Please enter the code',
    CommodityCategory: 'Category',
    PleaseChoose: 'Please Choose',
    TradeName: 'Trade Name',
    PleaseEnterContent: 'Please Enter Content',
    selectionCannot: 'The data selection cannot be empty, please select',
    discountPrice: 'Please set the discount price for the following goods',
    PriceModification: "Cannot be lower than the event's lowest discount price",
    GoodsActivityPrices: 'Product event price must be lower than',
    Time_limited: 'The event price only apply during the event time.',
    belowDiscount: 'Confirm to set discounts for the following products in batch?',
    GoodsInfo: 'Product Information',
    Category: 'Category',
    Pricef: 'Selling price',
    ActivityPricef: 'Event Price',
    Action: 'Operation',
    Cancelul: 'Delete',
    Edit: 'Modify event price',
    NotBeingable: 'You can go to the "Unacceptable Products" list page to check the reason',
    meetRequirements: 'products does not meet the application requirements',
    ConfiguredReconfigure: 'Please remove the product from configured event and then reset the event discounted price for the event',
    followingActivities: 'The following event have been configured for the current product:',
    ActivityOFPrice: 'Event Price',
    ActivityTitle: 'Activity title',
    VoidAboveReconfigure: 'Void the above event and set the discounted price of the current event',
    automaticallyInvalidates: 'After submission, the system will automatically invalidate the configured event of the current product, and recreate a limited time discount event for the current product ',
    EventList: 'Event List',
    ActivityTheme: 'Event name',
    GoodsImage: 'Product Image',
    OriginalPrice: "Original price",
    FlashSold: 'Flash Sale Sold',
    Event_product_details: 'flash sale product details',
    Cancel_registration: 'Cancel Application',
    Rule_of_activity: 'Flash Sale Rules',
    Activity_in_progress: 'Activity in progress',
    Activity_not_started: 'Activity not started',
    activity_ends: 'Finished',
    No_data_hint: 'You did not join the flash event    ',
    No_data_hint1: 'join now and get a lot of free traffic',
    headerDescription: '"Flash Sales" is Kilimall’s most distinctive limited-time limited flash sale business. It creates a "grab" atmosphere through limited-time single products to provide consumers with high-quality and low-priced goods, Can help the store get a lot of free traffic.',
    Selected_goods: 'Selected product',
    to_submit: 'To be submitted',
    submitted: 'submitted',
    Tips: 'Hint ',
    Tips1: '2.The greater discount, the higher ranking',
    Tips2: '3.SKUs that do not need to be apply for the flash sale, please just enter 0 at the  the inventory',
    Optional_product_list: 'Optional product list',
    Selected_product: 'Selected product',
    FlashSoldHint: 'There are still unsubmitted products, confirm to continue to skip',
    inventory: 'Inventory',
    editGoodsInfo: 'Edit flash sale product information',
    Batch_settings: 'Batch settings',
    Batch_settings_prices: "Set price in batch",
    Batch_settings_discounts: "Set discounts in bulk",
    Batch_settings_inventory: "Set inventory in batch",
    specification: 'Specification',
    Low_price: '30-day lowest price (excluding flash sale price)',
    Active_inventory_quantity: "SKU flash sale inventory",
    Flash_price: 'Flash sale price',
    jump_over: 'skip',
    Sign_up_successfully: 'Applied Successful',
    Sign_up_successfully1: 'Wait for the flash sale to start',
    Sign_up_successfully2: 'Flash sale started, product is on flash sale',
    Sign_up_successfully3: 'A large number of orders may be generated during the event, you can prepare in advance',
    Sign_up_successfully4: 'You can follow the application status in time from the application record',
    View_registration_details: 'View application details',
    In_Processing: "Pending Review",
    Approved: 'Approved',
    Refused: 'Rejected',
    Reduce: 'Reduce',
    record_list_hint: 'Delete this record. Do you want to continue?',
    Prices_prompt: 'The spike price you set is too low, there is a risk of loss, are you sure?',
    ProductTypes: 'Product Types',
    FlashSalesKili: 'Flash Sale is Kilimall’s special limited-time snap-up. It creates a “grab” business through single products that open groups within a limited time, providing consumers with high-quality and low-priced goods, and at the same time helping stores to drive product visits and sales, and form a small peak of store’s daily sales. After the transaction, it can increase the basic weight of the rproduct and increase the organic traffic.',
    DisplayMethod: 'Event Products Display Method'
  },
  SponsorPruduct: {
    CreateCampaign: 'Create Campaign:',
    Wewill: 'We will contact you to launch your campaign after your campaign is approved.',
    Inreview: 'In review',
    CampaignName: 'Campaign Name',
    SponsoredProducts: 'Sponsored Products',
    Budget: 'Budget',
    CampaignStatus: 'Campaign Status',
    Reviewed: 'Reviewed',
    Promoting: 'Promoting',
    Completed: 'Completed',
    Rejected: 'Rejected',
    Recalled: 'Recalled',
    ExpectedSchedule: 'Expected Schedule',
    Recall: 'Recall',
    Approved: 'Approved',
    Topromote: 'To promote',
    generatereport: 'To generate report',
    ViewReport: 'View Report',
    ViewPlacement: 'View Placement',
    Abolished: 'Abolished',
    CampaignReport: 'Campaign Report',
    CampaignPeriod: 'Campaign Period',
    Impressions: 'Impressions:',
    Clicks: 'Clicks:',
    ClickThroughRate: 'Click-Through Rate:',
    AverageCostperClick: 'Average Cost per Click:',
    Opportunities: 'Opportunities:',
    AdPlacement: 'Ad Placement',
    Nodata: 'No data',
    RejectedReason: 'Rejected Reason',
    CampaignName1: 'Campaign Name',
    Campaignname: 'Campaign name can not be empty',
    Budgetrmb: 'Budget (RMB)',
    budgetamount: 'Please enter the budget amount',
    contribute: 'Estimate that campaign will contribute',
    visits: 'visits',
    Budgetcan: 'Budget can not be empty',
    Schedule: "Expected Schedule:",
    StartDate: 'Start Date',
    EndDate: 'End Date',
    expected: 'The expected schedule date can not be empty',
    Selectproduct: 'Select product',
    Reselect: 'Reselect',
    beempty: 'Product selection cannot be empty',
    picture: 'Click on the picture to select the product',
    reselect: 'Click on the picture to re-select the product',
    Submit: 'Submit',
    sponsor: 'Please select the product you want to sponsor',
    ProductName: 'Product Name',
    aInformations: 'Product Information',
    Category: 'Category',
    Sales: 'Sales',
    Inventory: 'Inventory',
    ProductOriginal: 'Product Original Price',
    EventInventory: 'Event Inventory',
    SellerItem: 'Seller Item Id',
    Platform: 'Platform SKU-ID',
    ProductPrice: 'Product Price',
    Reasonfor: 'Reason for not being able to apply',
    selectedproduct: 'Please set the event price for the selected product.',
    Enterprice: 'Enter price',
    ComingUp: 'Coming Up',
    Active: 'Active',
    Completeds: 'Completed',
    PlatformId: 'Platform Product ID'
  },
  home: {
    ToDoList: 'To Do List',
    Things: 'Things you need to deal with',
    Pending: 'To Remind Payment',
    Dispatch: 'To Dispatch',
    Aftersale: 'To Process Aftersale',
    Cancellation: 'To Process Cancellation',
    Messages: 'To Reply Messages',
    Reviews: 'To Reply Reviews',
    Violating: 'Violating Policy Products',
    Replenishment: 'To Replenishment Products',
    Announcements: 'Announcements',
    More: 'More',
    Dashboard: 'Business Dashboard',
    Statistics: 'Statistics are the data of the past 7 days.',
    Trend: 'GMV Trend',
    GMV: 'GMV',
    Orders: 'Orders',
    Average: 'Average Order Value',
    Visitors: 'Visitors',
    Buyers: 'Buyers',
    Conversion: 'Conversion Rate',
    previous: 'Vs. previous period',
    Promotion: 'Promotion Events',
    EventTime: 'Event Time',
    JoinNow: 'Join Now',
    new: "New",
    username: 'Please enter username',
    password: 'Please enter password',
    Home: 'Home',
    Forgotpassword: 'Forgot password',
    Openshop: 'Open a shop',
    Forgotyourpassword: 'Forgot your password?',
    passwordreset: 'Please enter the account whose password you want to reset.',
    EmailVerification: 'Email Verification',
    PhoneVerification: 'Phone Verification',
    Enteryouremail: 'Enter your email',
    Emailverification: 'Email verification code',
    verification: 'Get verification code',
    Nextstep: 'Next step',
    youremail: 'Please enter your email',
    verificationcode: 'Please enter your email verification code',
    correctformat: 'The Email format is wrong, the correct format is as',
    registered: 'I have registered',
    SignIn: 'Sign In',
    Forexample: 'For example',
    phonenumber: 'Please enter your phone number',
    smsverification: 'Please enter your sms verification code',
    phoneformat: 'The phone number format is wrong, the correct format is as',
    Verificationerror: 'Verification code error',
    correctphone: 'Please enter the correct phone number',
    Resetpassword: 'Reset your password',
    newpassword: 'Enter your new password',
    Reenter: 'Re-enter your new password',
    confirmedpassword: 'The password is not as same as the confirmed password',
    Reset: 'Reset',
    HelpCenter: 'Help Center',
    zhi: '-',
    Wrongformat: 'Wrong phone number format',
    yourpassword: 'Please confirm your password',
    Wrongpassword: 'Wrong password format, correct format is as',
    icon_1: 'Gross Merchandise Value. Daily product amount of orders submitted by buyers in the past 14 days',
    icon_2: 'Gross Merchandise Value.The total product amount of all orders submitted by buyers in the past 7 days',
    icon_3: 'The total counts of all orders submitted by buyers in the past 7 days',
    icon_4: 'The average value of orders submitted by buyers in the past 7 days',
    icon_5: 'The sum of unique users who viewed your products in the past 7 days',
    icon_6: 'The sum of unique users who made purchases of your products in the past 7 days',
    icon_7: 'The percentage of visitors who made purchases of your products in the past 7 days',
    sms: 'SMS verification',
    resend: 'Resend',
    logOut: 'Logout',
    ViewRequirements: 'View video requirements',
    toConfirmRestockInvitations:'To Confirm Restock Invitations',
    toApplyRestockInvitations :'To Apply Restock Invitations',
    toDispatchRestockApplications :'To Dispatch Restock Applications',
    toNewSellerCenterTip: 'Kilimall platform is upgrading its system, and some of your orders will no longer be displayed in this old seller center. You need to quickly familiarize yourself with and learn the new seller center to handle the shipment and after-sales of potential new system orders to avoid loss of sales.',
    toNewSellerCenter: 'Go to new seller center'
  },
  afterSale: {
    Buyername: "Buyer's Name",
    OrderNo: "Order No",
    Orderamount: "Order Amount",
    Ordertime: "Order Time",
    Productquantity: "Product Quantity",
    Contactbuyer: "Contact Buyer",
    Pendingreview: "Pending Approval",
    Processing: "Processing",
    Completed: "Completed",
    Cancel: "Cancel",
    Reason: "Reason",
    Returnaddress: "Return Address",
    ReturnInstructions: "Return Desciption",
    Customervisible: "Customer Visible",
    Agreereturn: "Agree to Return",
    Confirmamount: "Confirm Refund Amount",
    Confirm: "Confirm",
    RejectReason: "Reject Reason",
    Rejectstatement: "Reject Description",
    uploadproofs: "Upload Proofs",
    ApplicationAmount: "Application Amount",
    Adjustamount: "Adjust Amount",
    Instructions: "Description",
    ReasonSupport: "Reason for Approval",
    Agreerefund: "Agree To Return & Refund",
    updateapplication: "Updated The Application",
    Refundonly: "Refund Only (No Need Return)",
    Agreerefund1: "Agree To Refund",
    Appeal: "Appeal",
    Adjustrefundamount: "Adjust Refund Amount",
    Agreerepair: "Agree To Repair",
    updateexupdate: "Change Solution To Exchange",
    updatesolutionrefund: "Change Solution To Return & Refund",
    agreeexupdate: "Approved For Exchange",
    rejectapplication: "Reject Application",
    Agreewithseller: "Agree With Seller",
    Goodsreceived: "Goods Received",
    consignment: "Dispatch Order",
    Qualityinspectionpassed: "Inspection Passed, Agree To Refund.",
    QualityPassed: "Inspection Passed",
    Qualityinspectionfailed: "Inspection Unpassed, Application Rejected.",
    Qualityupdate: "Inspection Passed,  Adjust Refund Amount & Approved.",
    Qualityexupdate: "Inspection Passed, Exchange Approved.",
    Qualityexupdate1: "Inspection Unpassed, Application Rejected.",
    Returnrefund: "Return & Refund",
    completed: "Completed",
    Aremodify: "Do you want to modify?",
    Doconfirm: 'Did you receive goods?',
    Servicemonths: "Waiting to be Processed ",
    Pleaseresolve: "Please deal with it in time.",
    Pendingapproval: "Pending Refund Approval",
    Tocustomer: "To be Shipped by customer",
    Waitinggoods: "To be Received by seller",
    Transactionnumber: "Transaction Order No.",
    AvailableTime: "Available Time",
    Startdate: "Start date",
    Enddate: "End date",
    ServiceorderNo: "Service Order No",
    Servicetype: "Service Type",
    ApplicationType: "Service Type",
    Refund: "Refund",
    repair: "Repair",
    exupdate: "Exchange",
    operate: "Operate",
    dealWith: "Deal With",
    View: "View Only",
    pendingArbitration: "Pending Arbitration",
    arbitrated: "Arbitrated",
    toBeDelivered: "To be Shipped",
    toBeResent: "To be Resent",
    toBeExchanged: "To be Exchanged",
    pendingReceipt: "To be Received",
    pendingReview: "Pending Approved",
    All: "All",
    Remaining: "End in",
    Day: "D",
    Hour: "H",
    minute: "M",
    second: "S",
    ArbitrationSituation: "Arbitration Situation",
    ArbitrationStatus: "Arbitration Status",
    ProcessingReason: "Processing Reason",
    ReasonReview: "Review comment",
    Remark: "Remark",
    Agreewitbuyer: "Agree With Buyer",
    AgreewithSeller: "Agree With Seller",
    ApplicationSituation: "Application Desciption",
    exupdateItem: "Exchange Item",
    cargoStatus: "Goods Status",
    ApplyType: "Application Service Type",
    ReasonApplication: "Application Reason",
    applicationTime: "Application Time",
    WeGoods: "Goods Received",
    WeNotGoods: "Goods not Received",
    GoodsSeller: "Goods Receipt status of seller",
    ShippingStatus: "Shipping Status",
    LogisticsAbnormalCancellation:"Logistics abnormal cancellation",
    cargoType: "Cargo Type",
    typeOfTransport: "Type of Transport",
    time: "Time",
    shipmentNumber: "Shipment No.",
    LogisticsCompanyName: "Logistics Company Name",
    DoorTime: "Door-to-door pickup time",
    ShippersName: "Shipper's name",
    ShippersPhone: "Shipper's phone",
    ShippersAddress: "Shipper's address",
    PickupStationName: "Pickup Station Name",
    PickupStationPhone: "Pickup Station Phone",
    PickupStationAddress: "Pickup Station Address",
    BuyerContact: "Buyer's Name",
    BuyerContactInformation: "Buyer's Phone No.",
    BuyerAddressInformation: "Buyer's Address",
    TheRefund: "If the logistics shows that it has been signed, the system accepts the goods by default",
    ComplaintNotReceived: "Complaint for not received",
    TimeoutNotHandled: "Timeout not handled",
    usedGoods: "Return goods",
    newGoods: "New goods",
    selfDelivery: "Self-delivery",
    DoorCollection: "Door-to-door Collection",
    DeliverStation: "Deliver to Pickup Station ",
    GoodsBuyer: "Return Status",
    typeTransport: "Type of Transport",
    ShipperName: "Receiver Name",
    ShipperInformation: "Receiver Contact",
    ReturnInformation: "Return Address",
    WaybillNumber: "Waybill Number",
    toBeShipped: "To be shipped",
    shipped: "Shipped",
    CancellationAfterSale: "Withdraw Aftersale Application",
    BuyersReceipt: "Buyer Receipt",
    returnContactInformation: "Shipper contact",
    SellerProcessStatus: "Seller Review Result",
    processInformation: "Operation information",
    BuyersConfirmation: "Buyer confirmation",
    processingTime: "Processing time",
    refundAmount: "Refund Amount",
    toBeConfirmed: "To be confirmed",
    confirmToAgree: "Approve",
    ApplyIntervention: "Apply for intervention",
    sellerRejectApplication: "Seller Rejected Application",
    sellerFailed: "Seller Rejected after inspection",
    sellerRefund: "Seller Change  solution to return & refund",
    sellerOnly: "Seller Change soulution to refund only",
    sellerAdjust: "Seller changes solution",
    sellerDeliveryInformation: "Seller dispatch information",
    sellerQualityInspection: "Seller inspection information",
    QualityInspectionStatus: "Inspection status",
    QualityInspectionFailed: "Inspection Unpassed",
    QualityAmount: "Inspection passed, adjust the Refund Amount & Approved",
    RefundSituation: "Refund Status",
    RequestARefundAmount: "Application Amount",
    RefundTime: "Refund Time",
    createTime: 'Created Time',
    completedTime: 'Completed Time', 
    RefundStatus: "Refund Status",
    RefundChannel: "Refund Channel",
    RefundSerialID: "Refund ID",
    RefundFailed: "Refund Failed",
    Refunding: "Refunding",
    RefundSuccessfully: "Refund Successfully",
    PendingRefund: "Pending Refund",
    pleaseEnter: 'Please enter',
    search: 'Search',
    OrderInformation: 'Order Information',
    AfterSaleOrderNo: 'After-sales Orders No.',
    OrderCreateTime: 'Order Create Time',
    pendingCheckQualtiy: 'Pending Quality Check',
    paymentTime: 'Payment Time',
    PaymentChannel: 'Payment Channel',
    logisticsType: 'Logistics type',
    storeId: 'Store ID',
    storeName: 'Store name',
    orderFinishTime: 'Completed time',
    agree: 'Agree',
    Shipping: 'Shipping',
    category: 'Category',
    SendToKilishop: 'Send to Kilishop',
    SendToG4S: 'Send to G4S',
    county: 'County',
    town: 'Town',
    PleaseChooes: 'Please Chooes',
    FBKconsignment: 'The logistics type of the current order is FBK. Please confirm whether to deliver the goods directly?',
    ViewLogisticsTrack: 'View Logistics Track',
    Revise: 'Revise',
    ReviewTheNote: 'Review The Note',
    ToBeConfirmedByMerchants: 'To be confirmed by merchants',
    MerchantsAgree: 'Merchants agree',
    MerchantsRefuseAfterSalesService: 'Merchants refuse after-sales service',
    MerchantsOfferNewSolutions: 'Merchants offer new solutions',
    theSystemAutomaticallyAgrees: 'If the merchant does not perform operations due to timeout, it automatically agrees',
    TheUserCancelsApplication: 'The user cancels the after-sales application',
    processingState: 'Process State',
    AddADefaultShippingAddress: 'Please add a  default shipping address.',
    noPickupAddress: 'There is currently no pickup address or no address selected',
    DoorToDoorAddress: "Door-to-door address",
    ReceiveAddress: "Receive address",
    setAddress: 'Set',
    PleaseSelectReason: 'Please select the reason',
    PleaseEnterRemarks: 'Please enter remarks',
    PleaseEnterRefundAmount: 'Please enter the refund amount',
    PleaseTrackingNumber: 'Please enter the logistics tracking number',
    PleaseSelectTown: 'Please select a town',
    SelectLogisticsCompany: 'Please select logistics company',
    PleaseSelectCounty: 'Please select a county',
    PleaseEnterContacName: 'Please enter your contact name',
    PleaseEnterPhoneNumber: 'Please enter a phone number',
    PleaseSelectAddress: 'Please select an address',
    applicationCancelled: "The arbitration application has been cancelled",
    fbk: "FBK",
    gs: "GS",
    ds: "DS",
    storeID: "Store  ID",
    listingID: "Listing ID",
    afterSaleOrderStatus: "Status",
    CompletedTime: "Completed time",
    goodsReceivedStatus: "Goods received status",
    inService: "In service",
    cancelled: "Cancelled",
    applicationRejectedBySeller: "application rejected by seller",
    received: "Received",
    unreceived: "Unreceived",
    rejectApplication:'Reject Application',
    export:'Export',
    exportTipMsg: 'please select the application Time range or completed time range.',
    whetherCanResold: "Is resellable",
    yesResealable: "New Resellable(FBK non-quality only) ",
    noResealable: "Non-resellable(FBK quality & GS & DS)",
    confirmRefundAmount1: "The full amount is",
    confirmRefundAmount2: ",and you are going to refund client",
    confirmRefundAmount3: ",are you sure?",
    shippersName: "Shipper's Name",
    shippersPhone: "Shipper's Phone No. ",
    productNotStockTip:'This product is out of stock, please chane the solution and confirm refund. ',
    opratorId:'Operator ID',
    arbitrationResult:'Arbitration Result',
    viewTrack:'view track',
    aftersaleOrderInformation:'Aftersale Order Information',
    customerApplication1:'Customer Application ',
    customerApplication2:' ,  Refund Amount: ',
    aftersaleNo:'Aftersale No',
    experienceNewVersion:'Experience the new version',
    aftersaleHistory:'Aftersale History',
    logistics: 'logistics',
    payment: 'payment',
  },
  storeAddress: {
    ShippingAddress: 'Shipping Address',
    ReturnAddress: 'Return Address',
    default: 'Default',
    addAddress: 'Add Address',
    editAddress: 'Edit Address',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    setAsDefault: 'Set as Default',
    AreYouSureDefaultAddress: 'Are you sure to set the current address as the default address?',
    AreYouSureToDeleteTheAddress: 'Are you sure to delete the address?',
    storeName: 'Store Name',
    country: 'Country',
    province: 'Province/County',
    city: 'City/Town',
    address: 'Address',
    contactName: 'Contact Name',
    phoneNumber: 'Phone Number',
    setDefaultAddress: 'Add a default shipping address. If the shipping address already exists, set the default address',
  },
  // 财务
  financeInfo: {
    billingPeriod: 'Settlement cycle',
    billDownload: 'Settlement report',
    downloadBill: 'Download',
    bankreceipt: 'Bank receipt',
    bill_text: 'If you have any questions about the settlement, please',
    customerService: 'contact merchant service support',
    weChatService: ' For details, please refer to FAQ ',
    shopFAQ: '<Kilimall Local Seller Settlement Policy>',
    completeInformation: 'Please contact the merchant service support to complete the settlement  cycle information.',
    pleaseChoose: 'Please select a Settlement cycle',
    chooseBill: 'Select Settlement period',
    notqueried: 'The Settelement report for the period you selected was not queried'
  },
  storeInfo: {
    shopId: 'Shop ID',
    shopName: 'Shop Name',
    shopLevel: 'Shop Level',
    merchantModel: 'Shop model',
    shopStatus: 'Shop status',
    close: 'Close',
    on: 'On',
    reviewing: 'Reviewing',
    startTime: 'Start Time',
    endTime: 'End Time',
    shopType: 'Shop type',
    contactName: 'Contact Name',
    contactPhone: 'Contact phone',
    email: 'Email',
    whatsapp: 'Whatsapp',
    wechat: 'Wechat',
    lastLoginTime: 'Last login time',
    shopCreateTime: 'Shop create time',
    commissionFree: 'Commission-free till',
    shopLogin: 'Shop login account',
    shopVacation: 'Shop vacation mode',
    merchantID: 'Merchant ID',
    merchantType: 'Merchant Type',
    companyName: 'Company Name',
    companyAddress: 'Company Address',
    addressDetail: 'Address detail',
    personName: 'Contact person name(Corportate)',
    IDType: 'ID type(Corportate)',
    IDNo: 'ID no. (Corportate)',
    validityPeriod: 'Validity period(Corportate)',
    Phoneno: 'Phone no(Corportate)',
    IDphotofront: 'ID photo front(Corportate)',
    IDphotoback: 'ID photo back(Corportate)',
    Businesslicense: 'Business license document',
    BusinessLicenseNumber: 'Business License Number',
    bankPhone: 'Contact no. (Bank reserved )',
    Paymentmethod: 'Payment method',
    Settlementcycle: 'Settlement cycle',
    Settlementcurrency: 'Settlement currency',
    Deposit: 'Deposit',
    Beneficiarybank: "Branch",
    bankCode: 'Bank Code',
    BankName: 'Bank',
    mpesaName: 'MPESA Registered Name',
    mpesaPhone: 'MPESA Phone Number',
    BankLocation: 'Bank Address',
    Accountname: 'Bank Account Name',
    Accountno: 'Bank Account Number',
    CompanyCountry: 'Company registered Country',
    cancel: 'Cancel',
    shopOperation: 'Shop Operation',
    closeShop: 'Close',
    reopen: 'Reopen',
    view: 'View',
    Setas: 'Set as run by Kilimall',
    confirm: 'Confirm',
    basicInformation: 'Basic information',
    settlementInfo: 'Settlement info',
    shopInformation: 'Shop information',
    customQuery: 'Custom query',
    exprot: 'Exprot',
    pleaseChoose: 'Please choose',
    unfilled: 'unfilled',
    individual: 'individual',
    company: 'company',
    idCard: 'ID card',
    passport: 'passport',
    BankCcard: 'Bank card',
    selectPeriod: 'Select a settlement period',
    SettlementInformation: 'Settlement account information',
    StoreType: 'Store type',
    ReasonClosing: 'Reason for closing',
    PleaseInformation: 'Please select information',
    exportNumber: 'Please enter the export number',
    closedRectification: 'Store closed for rectification',
    closeShop_tui: 'close shop',
    saleableCategory: 'saleable category',
    remind: 'Remind',
    reopenStore: 'Are you sure you want to reopen the store',
    reopened: 'The shop has reopened',
    shopClosed: 'The shop has closed',
    exportedItems: 'The number of exported items cannot exceed 2000',
    setStore: 'Sure to set it as a 1P store',
    setShopSuccess: 'Set as 1P shop successfully',
    suspend: 'Suspend', // 冻结 
    thaw: 'Activate', // 解冻
    suspendStore: 'Suspend store',
    activateStore: 'Activate store',
    suspendReason: 'Suspend reason',
    activatetheStore: 'Sure to activate the store？',
    sureSuspendStore: 'Sure to suspend the store？',
    PendingPaymentsStatement: 'Deposit Pending Statement',
    setBrandStore: 'Set as Official shop',
    setBP: 'Set as BP',
    settingBPO: 'Are you sure to setting the store to BPO?',
    cancalBrandStore: 'Cancel official store'
  },
  // 计划备货
  restockPlan: {
    addRestockProduct: 'Add Restock Product',
    affordableQty: 'Affordable Qty',
    arrivedQty: 'Arrived Qty',
    arrivedValueKSh: 'Arrived Value (KSh)',
    arrivedQtyRestock: 'Arrived Qty (% of Restock Qty)',
    appliedQtyRestock: 'Applied Qty (% of Restock Qty)',
    applyRestock: 'Apply Restock',
    applicationID: 'Application ID',
    applicationTime: 'Application Time',
    applyQty: 'Apply Qty',
    applyList: 'Apply List',
    all: 'All',
    arrivalDeadline: 'Arrival Deadline',
    approved: 'Approved',
    approvedRestockKsh: 'Approved Restock Value (KSh)',
    approvedRestockQty: 'Approved Restock Qty',
    appliedQty: 'Applied Qty',
    appliedValueKSh: 'Applied Value (KSh)',
    affordableValue: 'Affordable Value (KSh)',
    adminOperate: 'Admin Operate',
    applyQuantityUnapplied: 'Apply the same quantity as unapplied',
    back: 'Back',
    createTime: 'Create Time',
    category: 'Category',
    clear: 'Clear',
    closed: 'Closed',
    confirm: 'Confirm',
    columns: 'Columns',
    confirmTitle: 'You can NOT modify any products or numbers after confirmation. Affordable quantity might be changed by admins. Do you still want to confirm?',
    confirmPlan: 'Yes, confirm my plan',
    canNotGreater: "Can't be greater than",
    dispatchDeadline: 'Dispatch Deadline',
    dispatchedQty: 'Dispatched Qty',
    dispatchedQtyRestock: 'Dispatched Qty (% of Restock Qty)',
    dispatchedValueKSh: 'Dispatched Value (KSh)',
    dispatch: 'Dispatch',
    discard: 'Discard',
    delete: 'Delete',
    estimateShippingDay: 'Estimate Shipping Day',
    estShippingDay: 'Est. Shipping Day',
    estimatedShippingTip: "Estimated Shipping Day refers to the estimated departure day of your package on the carrier's vehicle (truck, airplane or cargo ship).",
    fillReasonInvitation: 'Fill in the reason why you reject this invitation.',
    gapQty: 'GAP Qty',
    gapValue: 'GAP Value(KSh)',
    invitationID: 'Invitation ID',
    invitationName: 'Invitation Name',
    id: 'ID',
    invitationDeadline: 'Invitation Deadline',
    inventory: 'Inventory',
    inTransit: 'In-Transit',
    invitationDetails: 'Invitation Details',
    image: 'Image',
    kindsOfSKU: 'Kinds of SKU',
    name: 'Name',
    netSent: 'Net Sent',
    netSent30: 'Net Sent R30',
    netSent90: 'Net Sent R90',
    noSelectColumn: 'You have to select at least 1 row',
    no: 'No',
    newAffordableQuantity: 'New Affordable Quantity',
    onOff: 'Off/On',
    operate: 'Operate',
    pleaseEnter: 'Please enter',
    pleaseSelect: 'Please select',
    planName: 'Plan Name',
    proposalQty: 'Proposal Qty',
    productName: 'Product Name',
    priceKsh: 'Price (KSh)',
    proposal: 'Proposal Qty',
    proposalValueKSh: 'Proposal Value (KSh)',
    proposalValue: 'Proposal Value',
    proposalWarehouse: 'Proposal Warehouse',
    pendingConfirm: 'Pending Confirm',
    productID: 'Product ID ',
    pendingApproval: 'Pending Approval',
    pendingConfirmation: 'Pending Confirmation',
    restockName: 'Restock Invitation Name',
    restockInvitationManagement: 'Restocking Invitations',
    ratings: 'Ratings',
    restockConfirmList: 'Restock Confirm List',
    restockQty: 'Restock Qty',
    restockValueKSh: 'Restock Value (KSh)',
    remarks: 'Remarks',
    reject: 'Reject',
    relatedRestockApply: 'Related Restock Applications',
    rejectTitle: "Reject means you don't want to restock any products in the list.",
    search: 'Search',
    shippingType: 'Shipping Type',
    selectWarehouse: 'Select Warehouse',
    selectShippingType: 'Select Shipping Type',
    selectProduct: 'Select Product',
    selectCategory: 'Select Category',
    submit: 'Submit',
    submitReject: 'Submit to Reject This Invitation',
    summary: 'Summary',
    save: 'Save',
    showHideColumns: 'Show / Hide Columns',
    sellerProposal: 'Seller Proposal?',
    status: 'Status',
    storeId: 'Store Id',
    storeName: 'Store Name',
    skuId: 'SKU ID',
    unappliedQty: 'Unapplied Qty',
    view: 'View',
    viewRestockInvitation: 'View Restock Invitation',
    warehouse: 'Warehouse',
    whyModify: 'Why modify',
    outOneSuccess: '1 out of 1 rows operated successfully!',
    noneSelectRows: 'None of the selected rows match the operation conditions.',
    noDataFound: 'No data found',
    upperLimit: 'Upper limit must be greater than lower limit',
    fillInTheReason: 'You have to fill in the reason why you reject this whole plan.',
    youFillInTheQuantity: 'You have to fill in the reason why you modify the affordable quantity.',
    fillInTheQuantity: 'Fill in the reason why you modify the affordable quantity.',
    chooseReason: 'You have to choose or fill in the reason why you modified the quantity.',
    newAffordableRequired: 'New affordable quantity is a required field.',
    selectReason: 'Select a reason',
    noAffordable: 'Please fill in the Affordable Quantity',
    pleaseInputStockQty: 'Please fill in the required Affordable Quantity for all applying products',
    proposalConservative: 'Proposal is too conservative,I want to sell more',
    proposalAggressive: "Proposal is too aggressive,I don't have the confident to sell out all",
    proposalMaximum: "Proposal is beyond my maximum purchase quantity",
    proposalSupplier: "Proposal is below the minimum order quantity required by my supplier",
    proposalBoxing: "Proposal is not the multiples of boxing",
    proposalDontMore: "I don't want to sell this item more",
    noneAbove: "None of the above reasons",
    tooLateApply: "Too late to apply restock",
    pleaceSelectWarehouse: "Please select warehouse",
    arrived: 'Arrived',
    cancelled: 'Cancelled',
    dispatched: 'Dispatched',
    inDraft: 'In Draft',
    sellerRejected: 'Seller Rejected',
    adminApproved: 'Admin Approved',
    adminRejected: 'Admin Rejected',
    equals: 'Equals',
    contains: 'Contains',
    mustFillBetween: 'You must fill in the upper limit or lower limit or both.',
    isEmpty:'Is Empty',
    notEmpty:'Not Empty',
    selectTheDate:'Select the date',
    add: 'Add',
    Reason: "Reason",
    platform: 'Platform',
    usePlatformLogistics: `Use platform's first leg logistics service`,
    selfDelivery: 'Cross-Border Seller Self-Delivery',
    noHeadTrip: 'Local Seller Self-Delivery',
    passed: 'Approved',
    rejected: 'Rejected'
  }
}